// @flow
import type { Epic } from '../../../annotations';

import { actionTypes, change } from 'redux-form';
import * as r from 'ramda';
import * as mostc from '../../../crosscutting/mostc';
import { select } from 'redux-most';

const filterTldEpic = (): Epic => (
  actions$,
) => r.pipe(
  select(actionTypes.CHANGE),
  mostc.filter(
    r.allPass([
      r.pathEq([ 'meta', 'form' ], 'domainFilters'),
      r.pipe(
        r.path([ 'meta', 'field' ]),
        r.contains('tld._'),
      ),
    ]),
  ),
  mostc.map(r.always(change('domainFilters', 'unspun', false))),
)(actions$);

export default filterTldEpic;
